// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3JW56","content":"LoadingAlert_content__7sMTs"};